import { Link } from 'react-router-dom'

import { AcornsIcon } from '@acorns/icons'
import { Badge } from '@acorns/web-components'
import styled from 'styled-components'

import { Heading2 } from 'components/typography'
import { style } from 'theme'

export const Wrapper = styled.div`
  max-width: 400px;
  width: 100%;
  margin: 30px auto auto;
  > div {
    width: 340px;
  }
  @media (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    max-width: 100%;
    > div {
      width: 100%;
    }
  }
`

export const CustomRowContent = styled.div`
  justify-content: flex-start;
  gap: 10px;
  position: relative;
  height: 128px;
`

export const StyledDrawerSubtitle = styled.span`
  font-size: 14px;
  line-height: 22px;
`

export const StyledDrawerSubtitleWithSuperscript = styled.div`
  margin: 10px 0 10px;
`

export const StyledHeading2 = styled(Heading2)`
  margin: 10px 0 10px;
  font-size: 16px;
  line-height: 24px;
`

export const StyledSuperscript = styled.sup`
  font-size: 10px;
  line-height: 22px;
`

export const DDIncentiveInfo = styled.div`
  margin-bottom: 40px;
`

export const StyledIncentiveLink = styled(Link)`
  font-size: 12px;
  line-height: 16px;
  color: ${style((theme) => theme.colors.stone)};
  text-decoration: none;
`

export const LearnMoreLink = styled(Link)`
  display: flex;
  color: ${style((theme) => theme.colors.green)};
  font-size: 14px;
  line-height: 22px;
  font-weight: 600;
  text-decoration: none;
`

export const StyledChevron = styled(AcornsIcon)`
  margin-left: 5px;
  path {
    &[fill] {
      fill: ${style((theme) => theme.colors.green)};
    }
  }
`

export const StyledDisclosureContent = styled.div`
  font-size: 14px;
  line-height: 22px;
`

export const StyledSelectorImg = styled.img`
  max-width: 180px;
  height: 98px;
  bottom: -20px;
  right: -58px;
  position: absolute;
  border-radius: 0 0 ${style((theme) => theme.borderRadius.large)} 0;
`

export const StyledBadge = styled(Badge)`
  background-color: ${style((theme) => theme.colors.purple)};
`
